import { request, requestBlob } from './request';

export const merchantApi = {
  createMerchantOrder: (data) => request('/api/merchant/orders', { method: 'POST', body: JSON.stringify(data) }),
  getMerchantRiderLocation: (orderId) => request('/api/merchant/orders/' + orderId + '/rider-location'),
  cancelMerchantOrder: (id) => request(`/api/merchant/orders/${id}/cancel`, { method: 'PATCH' }),

  getMerchantDashboard: (params) => {
    const qs = params ? '?' + new URLSearchParams(params).toString() : '';
    return request('/api/merchant/dashboard' + qs);
  },
  getMerchantReports: (params) => {
    const qs = params ? '?' + new URLSearchParams(params).toString() : '';
    return request('/api/merchant/reports' + qs);
  },
  /** Same A4 financial report payload as company portal (scoped to logged-in merchant). */
  getMyMerchantFinancialReport: (params) => {
    const qs = params ? '?' + new URLSearchParams(
      Object.fromEntries(Object.entries(params || {}).filter(([, v]) => v != null && v !== '')),
    ).toString() : '';
    return request(`/api/merchant/financial-report${qs}`);
  },
  getMerchantActiveReportDesign: (reportType) =>
    request(`/api/merchant/report-designs/active/${reportType || 'merchant_orders'}`),
  getMerchantReportFilters: () => request('/api/merchant/reports/filters'),
  exportMerchantReports: (params = {}) => {
    const { format = 'xlsx', ...rest } = params;
    const qs = '?' + new URLSearchParams({ ...rest, format }).toString();
    const ext = format === 'csv' ? 'csv' : 'xlsx';
    return requestBlob(`/api/merchant/reports/export${qs}`).then((blob) => {
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `merchant-report-${new Date().toISOString().slice(0, 10)}.${ext}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    });
  },
  getMerchantSettlementDetail: (id) => request(`/api/merchant/settlements/${id}`),
  getMerchantPendingSettlements: () => request('/api/merchant/settlements/pending'),
  confirmMerchantSettlementReceipt: (id) =>
    request(`/api/merchant/settlements/${id}/confirm-receipt`, { method: 'POST', body: JSON.stringify({}) }),

  getMerchantWorkflow: () => request('/api/merchant/workflow'),
  updateMerchantOrderStatus: (id, status, note) =>
    request(`/api/merchant/orders/${id}/status`, { method: 'PATCH', body: JSON.stringify({ status, note }) }),
  getMerchantProfile: () => request('/api/merchant/profile'),
  getMerchantOrders: (params) => {
    const qs = params ? '?' + new URLSearchParams(params).toString() : '';
    return request(`/api/merchant/orders${qs}`);
  },
  updateMerchantOrder: (id, data) => request(`/api/merchant/orders/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  updateMerchantOrderNotes: (id, notes) =>
    request(`/api/merchant/orders/${id}/notes`, { method: 'PATCH', body: JSON.stringify({ notes }) }),
  getMerchantShippingQuote: (params) => {
    const qs = params ? '?' + new URLSearchParams(params).toString() : '';
    return request(`/api/merchant/shipping-quote${qs}`);
  },
  getOrderLabelRendered: (id) => request(`/api/orders/${id}/label-rendered`),
  getOrderQr: (id) => request(`/api/orders/${id}/qr`),
  getOrderQrBlob: (id) => requestBlob(`/api/orders/${id}/qr`),
  bulkUploadMerchantOrders: (data) => request('/api/merchant/orders/bulk', { method: 'POST', body: JSON.stringify(data) }),
  validateBulkUploadOrders: (data) => request('/api/merchant/orders/bulk/validate', { method: 'POST', body: JSON.stringify(data) }),
  getBulkUploadDrafts: () => request('/api/merchant/orders/bulk/drafts'),
  getBulkUploadDraft: (id) => request(`/api/merchant/orders/bulk/drafts/${id}`),
  saveBulkUploadDraft: (data) => request('/api/merchant/orders/bulk/drafts', { method: 'POST', body: JSON.stringify(data) }),
  deleteBulkUploadDraft: (id) => request(`/api/merchant/orders/bulk/drafts/${id}`, { method: 'DELETE' }),

  getMerchantWarehouse: (params) => {
    const qs = params ? '?' + new URLSearchParams(
      Object.fromEntries(Object.entries(params || {}).filter(([, v]) => v != null && v !== '')),
    ).toString() : '';
    return request('/api/merchant/warehouse' + qs);
  },
  getMerchantWarehouseReport: (params) => {
    const qs = params ? '?' + new URLSearchParams(
      Object.fromEntries(Object.entries(params || {}).filter(([, v]) => v != null && v !== '')),
    ).toString() : '';
    return request('/api/merchant/warehouse/report' + qs);
  },

  getMerchantAiReportsChatStatus: () => request('/api/merchant/ai-reports-chat/status'),
  postMerchantAiReportsChat: (data) => request('/api/merchant/ai-reports-chat', {
    method: 'POST',
    body: JSON.stringify(data),
  }),

  getMerchantApprovalSettings: () => request('/api/merchant/approval-settings'),
  getMerchantApprovalQueue: (params) => {
    const qs = params ? '?' + new URLSearchParams(params).toString() : '';
    return request(`/api/merchant/orders/approval-queue${qs}`);
  },
  deleteMerchantPendingApprovalOrder: (id) =>
    request(`/api/merchant/orders/approval-queue/${id}`, { method: 'DELETE' }),
  resubmitMerchantOrder: (id) =>
    request(`/api/merchant/orders/${id}/resubmit`, { method: 'POST' }),
};